import { createContext, useContext } from "react";

type ClientLocationContextType = {
  location: string;
  isLoading: boolean;
};

export const ClientLocationContext = createContext<
  ClientLocationContextType | undefined
>(undefined);

export const useClientLocation = () => {
  const context = useContext(ClientLocationContext);
  if (context === undefined) {
    throw new Error(
      "useClientLocation must be used within a ClientLocationProvider"
    );
  }

  return context.location;
};
